import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'

export interface Locale {
  code: string
  name: string
  flag: string
}

interface LocaleSelectorProps {
  locales: Locale[]
  selected: string
  onChange: (code: string) => void
  bottom?: boolean
}

export function LocaleSelector({
  locales,
  selected,
  onChange,
  bottom = false,
}: LocaleSelectorProps) {
  const current = locales.find((l) => l.code === selected) ?? locales[0]

  return (
    <Menu
      as="div"
      data-test="locale-menu"
      className="relative inline-block text-left self-center sm:text-right z-10"
    >
      <Menu.Button className="inline-flex items-center ml-3 px-1 py-1 text-sm leading-4 font-medium bg-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 h-8 self-center dark:border-0 dark:bg-transparent dark:text-white">
        <span aria-label={current.name} role="img">
          {current.flag}
        </span>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={`${
            bottom
              ? 'origin-bottom left-3 bottom-8'
              : 'origin-top-right right-0'
          } absolute mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black/5 focus:outline-none dark:bg-darkPanelBg dark:ring-1 dark:ring-inset dark:ring-white/10`}
        >
          <div className="py-1">
            {locales.map(({ code, name, flag }) => (
              <Menu.Item key={code}>
                {({ active }) => (
                  <button
                    onClick={() => onChange(code)}
                    className={`${
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                    } block px-4 py-2 text-sm w-full text-left dark:bg-darkPanelBg dark:hover:bg-white/20 dark:text-white`}
                  >
                    <span className="mr-2" aria-hidden="true">
                      {flag}
                    </span>
                    {name}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
